// @flow

import type { Merchant } from '../types';
import { getMerchantConfig } from '../get-merchant-config';

export function getPaymentPageLogoUrl(merchant: Merchant): string {
  const merchantConfig = getMerchantConfig(merchant);

  if (!merchantConfig || !merchantConfig.payment_page_customization) {
    return '';
  }

  const customization = merchantConfig.payment_page_customization;

  if (!customization.merchant || !customization.merchant.logo_url) {
    return '';
  }

  return customization.merchant.logo_url;
}
